import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantTask } from '../mutations/deleteParticipantTask.mutation';
import type {
  DeleteParticipantTaskMutation,
  DeleteParticipantTaskMutationVariables,
} from '../types';

export const useDeleteParticipantTaskMutation = (
  options?: MutationOptions<DeleteParticipantTaskMutation, DeleteParticipantTaskMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantTask), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('tasks'),
      });
    },
  });
};
